module.exports = __webpack_public_path__ + "img/shield-icon.dd8476d2.png";